import line from './';
import {mixedMeasure} from '../default/';

function _facet () {
  const parent = this;
  const scale = this.__execs__.scale;
  const facet = this.facet();
  const canvas = this.__execs__.canvas;
  const innerSize = this.innerSize();
  const dimensions = this.isMixed() ? [this.dimensions()[0]] : [this.dimensions()[1]];
  const measures = this.isMixed() ? [mixedMeasure] : this.measures();
  let width, height;
  let settings = ['axisTitles', 'curve', 'meanLine', 'multiTooltip', 'normalized', 'padding' ,'point', 'pointRatio', 'regionPadding', 'shape', 'size', 'grid', 'font', 'highlightColor', 'label']
    .map(d => { return {key: d, value:this[d]()};});
  let hasX = this.axisX();
  let hasY = this.axisY();
  let smallLines = []; //sub-chart를 저장해둠
  let _smallLine = function(d,i) {
    let smallLine = line()
        .container(this)
        .data(d)
        .dimensions(dimensions).measures(measures)
        .width(width).height(height)
        .legend(false)
        .tooltip(false)
        .parent(parent) //부모 객체 던지기
        .zeroMargin(true) //마진 제거
        .aggregated(true) //선 처리 여부;
        .color(scale.color(d.data.key));
    settings.forEach(d => smallLine[d.key](d.value));
    if (hasY) smallLine.axis({target:'y', orient:'left'});//showTitle: facet.orient === 'horizontal' ? i === 0 : true});
    if (hasX) smallLine.axis({target:'x', orient:'bottom'});//showTitle: facet.orient === 'horizontal' ? true : i === arr.length-1});
    smallLine.render();
    smallLines.push(smallLine);
  }
  if (facet.orient === 'horizontal') {
    width =  scale.region.bandwidth();
    height = innerSize.height;
  } else {
    width = innerSize.width;
    height = scale.region.bandwidth();
  }

  canvas.selectAll('.facet')
    .each(_smallLine);
  smallLines.forEach(sm => { //sub-chart에서 이벤트가 발생하는 경우를 처리
    sm.on('selectStart.facet selectMove.facet selectEnd.facet', function(tick) { //이벤트 발생시 다른 sub-chart에 해당 이벤트 결과 값x,을 전달하여 표시
      //let start = event.type === 'mouseenter';
      smallLines.forEach(osm => {
        if(osm !== sm) {
          osm.showMultiTooltip(tick);
        }
      });
    })
  });
}

export default _facet;


// WEBPACK FOOTER //
// ./layouts/line/_facet.js